import './styles.css'
import ButtonComponent from '../app/components/elements/Button/index.vue'
import SaphePremiumPlusComponent from '../app/components/elements/logo/SaphePremiumPlus.vue'
import TopbarComponent from '../app/components/elements/Topbar/index.vue'
import CustomerCardComponent from '../app/components/elements/CustomerCard/index.vue'
import MessageBarComponent from '../app/components/elements/MessageBar/index.vue'
import BoxComponent from '../app/components/elements/Box/index.vue'
import InnerBoxComponent from '../app/components/elements/InnerBox/index.vue'
import HeadingsComponent from '../app/components/elements/Headings/index.vue'
import InputComponent from '../app/components/elements/Form/BaseInput/index.vue'
import SelectComponent from '../app/components/elements/Form/Select/index.vue'
import RadioOptionComponent from '../app/components/elements/Form/RadioOption/index.vue'
import ModalComponent from '../app/components/elements/Modal/index.vue'
import ButtonRoundComponent from '../app/components/elements/RoundButton/index.vue'
import DividerComponent from '../app/components/elements/Divider/index.vue'
import OverlayComponent from '../app/components/elements/Overlay/index.vue'
import ErrorMessageComponent from '../app/components/elements/ErrorMessage/index.vue'
import PillComponent from '../app/components/elements/Pill/index.vue'
import FeaturePillComponent from '../app/components/elements/FeaturePill.vue'
import LogoComponent from '../app/components/elements/logo/index.vue'
import PaneComponent from '../app/components/modules/ShopSidebar/Pane.vue'
import FooterComponent from '../app/components/modules/Shop/Footer.vue'
import PricingBreakdownComponent from '../app/components/webComponents/PricingBreakdown.vue'
import PillLabelColorComponent from '../app/components/modules/PillLabelColor.vue'

export const components = {
  button: defineCustomElement(ButtonComponent, {
    shadowRoot: false,
  }),
  pill: defineCustomElement(PillComponent, {
    shadowRoot: false,
  }),
  'feature-pill': defineCustomElement(FeaturePillComponent, {
    shadowRoot: false,
  }),
  footer: defineCustomElement(FooterComponent, {
    shadowRoot: false,
  }),
  pane: defineCustomElement(PaneComponent, {
    shadowRoot: false,
  }),
  logo: defineCustomElement(LogoComponent, {
    shadowRoot: false,
  }),
  'error-message': defineCustomElement(ErrorMessageComponent, {
    shadowRoot: false,
  }),
  'premium-plus': defineCustomElement(SaphePremiumPlusComponent, {
    shadowRoot: false,
  }),
  'customer-card': defineCustomElement(CustomerCardComponent, {
    shadowRoot: false,
  }),
  input: defineCustomElement(InputComponent, {
    shadowRoot: false,
  }),
  topbar: defineCustomElement(TopbarComponent, {
    shadowRoot: false,
  }),
  'message-bar': defineCustomElement(MessageBarComponent, {
    shadowRoot: false,
  }),
  box: defineCustomElement(BoxComponent, {
    shadowRoot: false,
  }),
  'inner-box': defineCustomElement(InnerBoxComponent, {
    shadowRoot: false,
  }),
  headings: defineCustomElement(HeadingsComponent, {
    shadowRoot: false,
  }),
  select: defineCustomElement(SelectComponent, {
    shadowRoot: false,
  }),
  'radio-option': defineCustomElement(RadioOptionComponent, {
    shadowRoot: false,
  }),
  modal: defineCustomElement(ModalComponent, {
    shadowRoot: false,
  }),
  'round-button': defineCustomElement(ButtonRoundComponent, {
    shadowRoot: false,
  }),
  divider: defineCustomElement(DividerComponent, {
    shadowRoot: false,
  }),
  overlay: defineCustomElement(OverlayComponent, {
    shadowRoot: false,
  }),
  'pricing-breakdown': defineCustomElement(PricingBreakdownComponent, {
    shadowRoot: false,
  }),
  'pill-label-color': defineCustomElement(PillLabelColorComponent, {
    shadowRoot: false,
  }),
}

for (const key in components) {
  const elementName = `saphe-${key}`

  if (!customElements.get(elementName)) {
    customElements.define(
      elementName,
      components[key as keyof typeof components]
    )
  }
}
